import { FC } from "react";
import Stack from "@mui/material/Stack";
import { AzureReservationCoverageDrawerChartHeader } from "./AzureReservationCoverageDrawerChartHeader";

import { AzureReservedInstanceDrawerChart } from "../common/AzureReservedInstanceDrawerChart";

import { AzureReservationDrawerDataGrid } from "../common/data-grid/AzureReservationDrawerDataGrid";

export const AzureReservationCoverageDrawerCoverageTab: FC = () => {
  return (
    <Stack px={0.5} bgcolor="white">
      <AzureReservedInstanceDrawerChart
        ChartHeader={AzureReservationCoverageDrawerChartHeader}
        type="coverage"
      />
      <AzureReservationDrawerDataGrid viewTab="coverage" />
    </Stack>
  );
};
